import React from "react";
import style from "./resultTherapies.module.scss";

function ResultTherapies() {

  return (
    <div className={style.result}>
      <div className="container">
        <h2 className={style.resultTitle}>Here is what to expect from your treatments</h2>
        <div className={style.resultContent}>

          <div className={style.resultContent__item}>
            <div className={style.resultContent__text}>As a rule of thumb, acute problems resolve faster than chronic
              ones. If you have a long standing chronic condition, your body has been stressed by it for a very long
              time and it will take some time to bring your body into balance and harmony.
              <h3 className={style.resultContent__title}>1</h3>
            </div>

          </div>

          <div className={style.resultContent__item}>
            <div className={style.resultContent__text}>All treatments are customized, but typically a series of 12
              weekly
              acupuncture treatments are scheduled for a diagnosis. You should expect to see some positive changes in
              your body in 2-3 treatments, with a bigger shift towards health after 4-6 treatments. As you start feeling
              better, we may decide to space your treatments farther apart.
              <h3 className={style.resultContent__title}>2</h3>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default ResultTherapies;